// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"Step2Prices_searchbar_pu9cA","parent-checkbox-hide":"Step2Prices_parent-checkbox-hide_3tcha"};